import {useInjection} from "@dp-instant/ui";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {BackButton} from "@game/ui/components/BackButton/BackButton";
import {CoinsIndicator} from "@game/ui/components/CoinsIndicator/CoinsIndicator";
import {StarsIndicator} from "@game/ui/components/StarsIndicator/StarsIndicator";
import {ShopPreview} from "@game/ui/components/Shop/ShopPreview";
import {apiClient} from "@game/api/ApiClient";
import cn from "classnames";
import {ShopMenu} from "../components/Shop/ShopMenu";
import "./ShopScreen.less";
import {useEffect} from "preact/hooks";

export const ShopScreen = () => {
    const model = useInjection<GameModel>(TypesGame.model);
    useEffect(() => {
        if (__SOCIAL__ === "tg") apiClient.trackFunnelEvent("shop_opened");
        return () => model.onShopScreenChanged(); // select skins when ShopScreen removed
    }, []);
    return (
        <div className={cn("screen", "screen__shop")}>
            <div className={cn("screen-top", "visible")}>
                <div className={cn("container", "top-bar")}>
                    <BackButton
                        onClick={() => {
                            model.goToLobby();
                        }}
                    />
                    <div className="top-bar__currencies">
                        <CoinsIndicator
                            className={cn("coins-indicator", "coins-indicator_filled")}
                            total={model.cookie.coins}
                        />
                        {__SOCIAL__ === "tg" && (
                            <StarsIndicator
                                className={cn("stars-indicator", "stars-indicator_filled")}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className={cn("container", "shop-area")}>
                <ShopPreview />
                <ShopMenu />
            </div>
        </div>
    );
};
